import { Fade } from "react-awesome-reveal";

export function Politica() {
  return (
    <section className="flex items-center justify-center py-40 max-[1024px]:py-28">
      <div className="container">
        <div className="pt-12 max-[1024px]:pt-0 lg:flex lg:flex-col">
          <Fade delay={200}>
            <h2 className="text-center font-roboto text-3xl font-bold text-purple-950 max-[1024px]:text-center max-[1024px]:text-3xl max-[480px]:text-2xl">
              Política de Privacidade – ONG Cabelegria <br />
              Última atualização: <span>23/05/2025</span>
            </h2>
          </Fade>
        </div>
        <div className="pb-4 pt-12 max-[1024px]:pt-6 lg:flex lg:flex-col">
          <Fade delay={250}>
            <p className="pb-4 text-sm font-normal text-purple-950">
              A ONG Cabelegria tem o compromisso com a transparência e a
              privacidade de todos os doadores, apoiadores e visitantes do nosso
              site. Esta Política de Privacidade tem como objetivo explicar, de
              forma clara e acessível, como coletamos, utilizamos, armazenamos e
              protegemos seus dados pessoais, em conformidade com a{" "}
              <strong>
                Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018 –
                LGPD).
              </strong>
            </p>
          </Fade>
        </div>
        <div className="border border-b-purple-950" />
        <div className="py-4 max-[1024px]:pt-0 lg:flex lg:flex-col">
          <Fade delay={300}>
            <p className="pb-4 text-sm font-normal text-purple-950 max-[1024px]:pt-4">
              <strong>1. Quais dados coletamos</strong> <br />
              <br />
              Ao solicitar o certificado de doação de cabelo, podemos coletar os
              seguintes dados: <br />
              <br />
              <ul className="list-disc pl-6">
                <li>Nome completo (obrigatório)</li>
                <li>
                  Endereço de e-mail <strong>(opcional)</strong>
                </li>
                <li>
                  Número de WhatsApp <strong>(opcional)</strong>
                </li>
              </ul>
              <br />O fornecimento dos dados de e-mail e WhatsApp é opcional e
              requer o seu consentimento para que possamos utilizá-los em
              comunicações futuras sobre a ONG.
            </p>
          </Fade>
        </div>
        <div className="border border-b-purple-950" />
        <div className="py-4 max-[1024px]:pt-0 lg:flex lg:flex-col">
          <Fade delay={350}>
            <p className="pb-4 text-sm font-normal text-purple-950 max-[1024px]:pt-4">
              <strong>2. Finalidade do uso dos dados</strong> <br />
              <br />
              Seus dados são coletados e tratados com as seguintes finalidades:{" "}
              <br />
              <br />
              <ul className="list-disc pl-6">
                <li>Emissão do certificado digital de doação;</li>
                <li>
                  Envio de{" "}
                  <strong>newsletter institucional da ONG Cabelegria</strong>,
                  com informações sobre campanhas, eventos e projetos
                  relacionados à nossa missão.
                </li>
              </ul>
              <br />
              <strong>
                Nunca utilizamos seus dados para fins comerciais ou os
                compartilhamos com terceiros.
              </strong>
            </p>
          </Fade>
        </div>
        <div className="border border-b-purple-950" />
        <div className="py-4 max-[1024px]:pt-0 lg:flex lg:flex-col">
          <Fade delay={400}>
            <p className="pb-4 text-sm font-normal text-purple-950 max-[1024px]:pt-4">
              <strong>3. Base legal</strong> <br /> <br />O tratamento dos seus
              dados pessoais é realizado com base no seu{" "}
              <strong>consentimento livre, informado e inequívoco,</strong>{" "}
              conforme previsto no artigo 7º, inciso I da LGPD.
            </p>
          </Fade>
        </div>
        <div className="border border-b-purple-950" />
        <div className="py-4 max-[1024px]:pt-0 lg:flex lg:flex-col">
          <Fade delay={300}>
            <p className="pb-4 text-sm font-normal text-purple-950 max-[1024px]:pt-4">
              <strong>4. Armazenamento e segurança dos dados</strong> <br />
              <br />
              Os dados são armazenados em ambiente seguro e controlado, com{" "}
              <strong>
                acesso restrito exclusivamente a uma pessoa autorizada da equipe
                da ONG Cabelegria.
              </strong>{" "}
              O período de armazenamento é de até{" "}
              <strong>11 (onze) meses,</strong> considerando a finalidade de
              manter o histórico de doações e emissão de certificados. Adotamos
              medidas técnicas e administrativas para proteger os dados pessoais
              contra acessos não autorizados, perda, alteração ou divulgação
              indevida.
            </p>
          </Fade>
        </div>
        <div className="border border-b-purple-950" />
        <div className="py-4 max-[1024px]:pt-0 lg:flex lg:flex-col">
          <Fade delay={350}>
            <p className="pb-4 text-sm font-normal text-purple-950 max-[1024px]:pt-4">
              <strong>5. Seus direitos como titular de dados</strong> <br />
              <br />
              Nos termos da LGPD, você tem o direito de: <br />
              <br />
              <ul className="list-disc pl-6">
                <li>Confirmar a existência do tratamento de seus dados;</li>
                <li>Acessar os dados armazenados;</li>
                <li>Corrigir dados incompletos, inexatos ou desatualizados</li>
                <li>
                  Solicitar a anonimização, bloqueio ou eliminação dos dados;
                </li>
                <li>Revogar o seu consentimento a qualquer momento.</li>
              </ul>
              <br />
              Para exercer seus direitos, entre em contato conosco pelo e-mail:{" "}
              <a href="mailto:comunicacao@cabelegria.org">
                <strong>comunicacao@cabelegria.org</strong>
              </a>
            </p>
          </Fade>
        </div>
        <div className="border border-b-purple-950" />
        <div className="py-4 max-[1024px]:pt-0 lg:flex lg:flex-col">
          <Fade delay={400}>
            <p className="pb-4 text-sm font-normal text-purple-950 max-[1024px]:pt-4">
              <strong>6. Consentimento e cancelamento</strong> <br />
              <br />
              Ao preencher seus dados no site da ONG Cabelegria, você declara
              estar ciente desta Política de Privacidade e{" "}
              <strong>
                autoriza o uso das informações nos termos aqui descritos.
              </strong>{" "}
              Você poderá, a qualquer momento, solicitar o{" "}
              <strong>
                cancelamento do envio de comunicações ou a exclusão de seus
                dados pessoais,
              </strong>{" "}
              mediante solicitação por e-mail.
            </p>
          </Fade>
        </div>
        <div className="border border-b-purple-950" />
        <div className="py-4 max-[1024px]:pt-0 lg:flex lg:flex-col">
          <Fade delay={600}>
            <p className="pb-4 text-sm font-normal text-purple-950 max-[1024px]:pt-4">
              <strong>7. Alterações nesta política</strong> <br />
              <br />
              Esta Política de Privacidade pode ser atualizada a qualquer
              momento, visando adequações legais ou melhorias na transparência.
              Recomendamos que você a revise periodicamente.
            </p>
          </Fade>
        </div>
        <div className="border border-b-purple-950" />
        <div className="py-4 max-[1024px]:pt-0 lg:flex lg:flex-col">
          <Fade delay={650}>
            <p className="pb-4 text-sm font-normal text-purple-950 max-[1024px]:pt-4">
              <strong>8. Contato</strong> <br />
              <br />
              Se você tiver dúvidas sobre esta Política de Privacidade ou sobre
              o tratamento dos seus dados, entre em contato conosco: <br />
              <br />
              📧{" "}
              <a href="mailto:comunicacao@cabelegria.org">
                comunicacao@cabelegria.org
              </a>{" "}
              <br /> 🌐 <a href="/">www.cabelegria.org</a>
            </p>
          </Fade>
        </div>
      </div>
    </section>
  );
}
